import Glide from "@glidejs/glide";

export default function workSlider() {
	new Glide(".glide-works", {
		type: "slider",
		startAt: 0,
		perView: 3,
		gap: 40,
		bound: true,
		perTouch: 1,
		animationDuration: 500,
		peek: {
			before: 0,
			after: 110
		},
		breakpoints: {
			920: {
				perView: 2,
				gap: 30
			},
			640: {
				perView: 1,
				gap: 25,
				peek: {
					before: 0,
					after: 60
				}
			}
		}
	}).mount();
}
